module.exports = __webpack_public_path__ + "static/img/social_9.2b3d2bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/launch/social/social_9.jpg
// module id = U2qL
// module chunks = 1